module.exports = __webpack_public_path__ + "static/morethancode-1992d4295f1537b9b7ffd7d881269435.png";